export class SearchResult {
    count: number;
    data: any;
    constructor(item) {
        this.data = item.data;
        this.count = item.count
    }
}